import { render, staticRenderFns } from "./Inhaler.vue?vue&type=template&id=7579058b&"
import script from "./Inhaler.vue?vue&type=script&lang=js&"
export * from "./Inhaler.vue?vue&type=script&lang=js&"
import style0 from "./Inhaler.vue?vue&type=style&index=0&id=7579058b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports